var render, staticRenderFns
import script from "./radarChart.vue?vue&type=script&lang=js&"
export * from "./radarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d83f87c",
  null
  
)

export default component.exports